"use client";

import { c as _c } from "react/compiler-runtime";
import { HeroHeader } from "./hero";
import { NowMintingSection } from "./now-minting";
import { NextMintLeadingSection } from "@/components/home/next-mint-leading/NextMintLeadingSection";
import { BoostedSection } from "@/components/home/boosted/BoostedSection";
import { ExploreWavesSection } from "@/components/home/explore-waves/ExploreWavesSection";
export default function HomePageContent() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HeroHeader />;
    t1 = <NowMintingSection />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-overflow-x-hidden tw-border-y-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-iron-900">{t0}{t1}<div className="tw-pt-10 md:tw-pt-16"><NextMintLeadingSection /><BoostedSection /><ExploreWavesSection /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}